import { onReady } from "../../utils/events/onReady";

export class GatedContent {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined,
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */

    constructor(domReference) {
        this.dom.container = domReference;
        this.dom.hash = window.location.hash;

        onReady(() => this.init(domReference));
    }

    attachGatedContentProperties(target) {
        if (!target || !this.dom.hash) {
            return;
        }

        // The fragment never reaches the server, so append it to the returnUrl value
        const url = new URL(target.getAttribute("href"), window.location.href);
        const returnUrl = url.searchParams.get("returnUrl");
        if (returnUrl !== null && !returnUrl.includes("#")) {
            url.searchParams.set("returnUrl", returnUrl + this.dom.hash);
            target.setAttribute("href", url.toString());
        }
    }

    init(domReference) {
        const target = domReference.querySelector(".button--icon-cta");
        this.attachGatedContentProperties(target);
    }
}
